import { UltimateBuyersGuideCarousal, HubspotBrochureDownload } from '.'

const UltimateBuyersGuide = (props) => {
  return (
    <>
      <section className="contentmainN ptb0 pt-5">
        <div className="container customCampaignContainer">
          <div className="row d-flex align-items-center">
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 ">
              <div className="subTextHeading text-left">You will get to learn:</div>
              <div>
                <ul className="mainbullets mt-4">
                  <li>Get insights on why employee wellness is crucial.</li>
                  <li>Learn how to handpick the right wellness program.</li>
                  <li>An action plan to create a wellness program for your workforce.</li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 text-center" id="implementationCarousel">
              <UltimateBuyersGuideCarousal />
            </div>
          </div>
        </div>
      </section>
      <div id="downloadForm"></div>
      <section className="sectionSpacing">
        <div className="container customCampaignContainer">
          <div className="row">
            <div
              className="col-md-6 col-md-offset-2  col-sm-offset-2 col-xs-12 col-sm-12 col-lg-6 col-lg-offset-2 text-center shadow"
              style={{ margin: 'auto', borderRadius: '16px', padding: '60px 30px' }}
            >
              <div className="mainHeadingN ">Download Now</div>
              <div className="innerSpace guide-form">
                <HubspotBrochureDownload formID="4137f3b0-51f2-4560-af98-9648b98bf9e2" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default UltimateBuyersGuide
